import {createSlice} from "@reduxjs/toolkit";

const initialSensorControlState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  // entities: null,
  entities:[],
  SensorControlForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const SensorControlSlice = createSlice({
  name: "SensorControl",
  initialState: initialSensorControlState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSensorCotrolById
    SensorCotrolFetched: (state, action) => {
      state.actionsLoading = false;
      state.SensorControlForEdit = action.payload.SensorControlForEdit;
      state.error = null;
    },
    // findControls
    SensorControlsFetched: (state, action) => {
      const { count, data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = data;
      state.totalCount = count;
     
    },
    // createSensorControl
    SensorControlCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.data);
    },
    // updateSensorControl
    SensorControlUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.SensorControl.id) {
          return action.payload.SensorControl;
        }
        return entity;
      });
    },
    // deletesENSORControl
    SensorControlDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
   
   
  }
});
